export enum ListingsType {
    Free = 'Free (Basic)',
    Starter = 'Starter',
    Professional = 'Professional',
    Enterprise = 'Enterprise'
}